export default function BulletIcon() {
  return (
    <svg
      width="6"
      height="6"
      viewBox="0 0 6 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="3" cy="3" r="3" fill="url(#paint0_linear_918_118358)" />
      <defs>
        <linearGradient
          id="paint0_linear_918_118358"
          x1="-0.6"
          y1="7.74"
          x2="7.79682"
          y2="6.2758"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#830051" />
          <stop offset="1" stopColor="#FF6D42" />
        </linearGradient>
      </defs>
    </svg>
  )
}
